import React, { useEffect, useRef } from "react";
import Chart from "chart.js/auto";
import { Box, Stack, Text } from "@mantine/core";
import { DashboardCommonLayout } from "./DashboardCommonLayout";
import LAst7aysButton from "../../assets/img/Button.svg";
import DoughnutChart from "./PatientAnalytics";

interface DoughnutChartProps {
  data: number[];
  labels: string[];
  colors: string[];
  d1: any;
  d2: any;
  d3: any;
  d4: any;
}

const Analytics: React.FC<DoughnutChartProps> = ({
  data,
  labels,
  colors,
  d1,
  d2,
  d3,
  d4,
}) => {
  const chartRef = useRef<HTMLCanvasElement>(null);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        backgroundColor: "white",
        borderRadius: "8px",
        padding: "8px",
      }}
    >
      <DashboardCommonLayout
        componentName="Patient Analytics"
        children={
          <Box>
            <img src={LAst7aysButton} />
          </Box>
        }
      />
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            justifyContent: "flex-start",

            gap: "18px",
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "row" }}>
            <Stack
              sx={{
                width: "16px",
                height: "16px",
                borderRadius: "46px",
                backgroundColor: "#00A651",
                marginRight: "8px",
              }}
            ></Stack>
            <Text
              sx={{ fontWeight: 400, fontSize: "14px", lineHeight: "20px",display:"flex",alignItems:"center" }}
            >
              Patient Age above 60:
            </Text>
            <Text sx={{ marginLeft: "8px" }}>{d1}</Text>
          </Box>
          <Box sx={{ display: "flex", flexDirection: "row" }}>
            <Stack
              sx={{
                width: "16px",
                height: "16px",
                borderRadius: "46px",
                backgroundColor: "#FF9F43",
                marginRight: "8px",
              }}
            ></Stack>
            <Text
              sx={{ fontWeight: 400, fontSize: "14px", lineHeight: "20px" }}
            >
              Female:
            </Text>
            <Text sx={{ marginLeft: "8px" }}>{d2}</Text>
          </Box>
          <Box sx={{ display: "flex", flexDirection: "row" }}>
            <Stack
              sx={{
                width: "16px",
                height: "16px",
                borderRadius: "46px",
                backgroundColor: "red",
                marginRight: "8px",
              }}
            ></Stack>
            <Text
              sx={{ fontWeight: 400, fontSize: "14px", lineHeight: "20px" }}
            >
              Male:
            </Text>
            <Text sx={{ marginLeft: "8px" }}>{d3}</Text>
          </Box>
          <Box sx={{ display: "flex", flexDirection: "row" }}>
            <Stack
              sx={{
                width: "16px",
                height: "16px",
                borderRadius: "46px",
                backgroundColor: "#1B75BC",
                marginRight: "8px",
              }}
            ></Stack>
            <Text
              sx={{ fontWeight: 400, fontSize: "14px", lineHeight: "20px" }}
            >
              Surgery consultation:
            </Text>
            <Text sx={{ marginLeft: "8px" }}>{d4}</Text>
          </Box>
        </Box>
        <Box
          sx={{
            width: "127px",
            height: "130px",
            marginRight: "22px",
            marginTop: "5px",
          }}
        >
          <DoughnutChart data={data} labels={labels} />
        </Box>
      </Box>
    </Box>
  );
};

export default Analytics;
